module.exports = __webpack_public_path__ + "static/media/azzarowanted.247e1e25.png";